export enum FeatureFlag {
	CreateEditableWordTemplate = 'create-editable-word-template',
}
